import React from 'react';
import styles from '../assets/styles/ServiceDescriptionSection.module.css';

const ServiceDescriptionSection = ({ header, content }) => {
  return (
    <div>
      <div className={styles.serviceDescriptionSection}>
        <div className={styles.header}>{header}</div>
        <div className={styles.content}>{content}</div>
      </div>
    </div>
  );
};

export default ServiceDescriptionSection;